import { BlockPosition } from '@website-builder/model/style/block-position';

export class GeneralStyle {
  outline = '';
  margin = '';
  removeTopMargin = '';
  removeBottomMargin = '';
  width = '';
  blockAlignment = '';
  blockAlignmentBreakpoint = '';
  blockAlignmentFallback = '';
  backgroundColor = '';
  padding = '';
  textAlignment = '';
  textAlignmentBreakpoint = '';
  textAlignmentFallback = '';
  visibility = '';
  animation = '';
  animationDelay = 0;
  repeatAnimation = false;
  useParallax = false;
  parallaxValues = [];
  parallaxBreakpoint = '';
  blockPosition = new BlockPosition();

  static normalize(styles: Partial<GeneralStyle>): GeneralStyle {
    const generalStyle = new GeneralStyle();

    generalStyle.outline = styles?.outline ?? generalStyle.outline;
    generalStyle.margin = styles?.margin ?? generalStyle.margin;
    generalStyle.removeTopMargin = styles?.removeTopMargin ?? generalStyle.removeTopMargin;
    generalStyle.removeBottomMargin = styles?.removeBottomMargin ?? generalStyle.removeBottomMargin;
    generalStyle.width = styles?.width ?? generalStyle.width;
    generalStyle.blockAlignment = styles?.blockAlignment ?? generalStyle.blockAlignment;
    generalStyle.blockAlignmentBreakpoint = styles?.blockAlignmentBreakpoint ?? generalStyle.blockAlignmentBreakpoint;
    generalStyle.blockAlignmentFallback = styles?.blockAlignmentFallback ?? generalStyle.blockAlignmentFallback;
    generalStyle.backgroundColor = styles?.backgroundColor ?? generalStyle.backgroundColor;
    generalStyle.padding = styles?.padding ?? generalStyle.padding;
    generalStyle.textAlignment = styles?.textAlignment ?? generalStyle.textAlignment;
    generalStyle.textAlignmentBreakpoint = styles?.textAlignmentBreakpoint ?? generalStyle.textAlignmentBreakpoint;
    generalStyle.textAlignmentFallback = styles?.textAlignmentFallback ?? generalStyle.textAlignmentFallback;
    generalStyle.visibility = styles?.visibility ?? generalStyle.visibility;
    generalStyle.animation = styles?.animation ?? generalStyle.animation;
    generalStyle.animationDelay = styles?.animationDelay ?? generalStyle.animationDelay;
    generalStyle.repeatAnimation = styles?.repeatAnimation ?? generalStyle.repeatAnimation;
    generalStyle.useParallax = styles?.useParallax ?? generalStyle.useParallax;
    generalStyle.parallaxValues = styles?.parallaxValues ?? generalStyle.parallaxValues;
    generalStyle.parallaxBreakpoint = styles?.parallaxBreakpoint ?? generalStyle.parallaxBreakpoint;
    generalStyle.blockPosition = BlockPosition.normalize(styles.blockPosition);

    return generalStyle;
  }
}
